import { fromJS } from 'immutable';
import { findPropertiesByScope } from '@pearsontechnology/aero-plugin-schema';

export function composeState(schema, config, scope) {
  /* state object based on config  */
  let state = fromJS(config || {});

  /* immutable version of scope to get properties by path */
  const immutableScope = fromJS(scope || {});

  /* definition of scope and config properties from schemas */
  const scopeProperties = findPropertiesByScope(schema);

  /* add scope items to state */
  scopeProperties.forEach((propertyDescriptor) => {
    const { path } = propertyDescriptor;
    state = state.setIn(path, immutableScope.getIn(path, state.getIn(path)));
  });

  return state.toJS();
}
